export function getCursonPosition(inputRef) {
  return inputRef.current?.selectionEnd || 0;
}

export function calcCursorPosition(inputValue, prevValue, formattedResult) {
  // если после изменения символов строка сформатиловалась как и была
  // то просто передвигаем курсор на кол-во измененных символов
  let { cursor } = formattedResult;
  const lengthDiff = inputValue.length - formattedResult.value.length;

  if (lengthDiff < 0) {
    if (cursor && prevValue === formattedResult.value) {
      cursor += lengthDiff;
    }
  } else if (lengthDiff > 0) {
    if (!cursor && prevValue === formattedResult.value) {
      cursor -= lengthDiff;
    }
  }

  return cursor;
}

export function moveCursorPosition(inputRef, cursorPosition) {
  if (inputRef.current) {
    inputRef.current.selectionStart = cursorPosition;
    inputRef.current.selectionEnd = cursorPosition;
  }
}
